import { render, staticRenderFns } from "./LabelsBar.vue?vue&type=template&id=361cfa89"
import script from "./LabelsBar.vue?vue&type=script&lang=js"
export * from "./LabelsBar.vue?vue&type=script&lang=js"
import style0 from "./LabelsBar.vue?vue&type=style&index=0&id=361cfa89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports